import { Formulario } from './formulario.types';
import { Projeto } from './projeto.types';

// CONDO_AVALIATIONS_LAYER = 'Avaliações Condomínios',
// DEFAULT_LOT_AVALIATIONS_LAYER = 'Avaliações Lote Padrão',
// SAMPLE_LAYER = 'Amostras',

export enum LayerRepresentation {
  PVG = 'PVGEO',
  SECTOR = 'Setor Censitário',
  COLLAB_SAMPLES = 'Amostras Colaborativa',
  SAVED_AVAL = 'Avaliações Salvas',
  LOTS = 'Lotes',
  LOTES_RURAIS = 'LotesRurais',
  TERRAIN_AVAL = 'Avaliação Terreno',
  CONSTRUCTION_AVAL = 'Avaliação Construção',
  REGRESSION = 'Regressão Multipla',
  COMERCIAL_FACTOR = 'fcomercializacao',
  ZONE = 'Plano Diretor',
  VALUATION_PREVIEW = 'VALUATION_PREVIEW',
  LOTES2 = 'Lotes2',
  EDFS2 = 'Edificacoes2',
  LOGRADOUROS2 = 'Logradouros2',
  FOTOS_360 = 'Fotos360',
  LOTE_DEFAULT = 'lote',
  EDF_DEFAULT = 'edificacao',
  LOGRADOURO_DEFAULT = 'logradouro',
  BAIRRO_DEFAULT = 'bairro',
  FOTO_360_DEFAULT = 'foto_360',
}

export enum LayerNames {
  SECTOR_LAYER = 'Setor Censitário',
  CUSTOM_AVALIATIONS_LAYER = 'Avaliações Personalizadas',
  CONSTRUC_AVALIATIONS_LAYER = 'Avaliações Construção',
  TERRAIN_AVALIATIONS_LAYER = 'Avaliações Terreno',
  SAVED_AVALIATIONS_LAYER = 'Avaliações Salvas',
  SAMPLE_COLLAB_LAYER = 'Amostras Colaborativa',
  SAMPLE_LAYER_TERRAIN = 'Amostras Terrenos',
  SAMPLE_LAYER_CONSTRUCTIONS = 'Amostras Edificações',
  ADJUSTMENT_ZONE_LAYER = 'Zona de Ajuste',
  GEO_DOMAIN_LAYER = 'Domínio Geográfico',
  LOGRA_LAYER = 'Logradouros',
  GLEBA_LAYER = 'Avaliações Gleba',
}
export interface Camada {
  id: number;
  nome?: string;
  tipoGeometria?: string;
  projeto?: Projeto;
  geoms?: string;
  projetosCamadasFormularios: Formulario[];
  ativo?: boolean;
  representacao: string;
  equacao?: string;
  podeExcluir?: boolean;
  ordemVisualizacao?: number;
  qtdGeometrias?: number;
  // publicoOuv?: boolean;
  // showOuv?: boolean;
  sldBody?: string;
  sldBodyOuv?: string;
  cor?: string;
  espessura?: string;
  preenchimento?: string;
  adicional?: boolean;

  tblNomeDb?: string;
  url?: string;

  privada?: boolean;
  showOuv?: boolean;
  showIcad?: boolean;
  publicoOuv?: boolean;
  publicoIcad?: boolean;
  showPrevia?: boolean;
  showAvaliacao?: boolean;

  estiloWebgeo?: string;
  estiloIcad?: string;
  estiloConsultaPrevia?: string;
  estiloAvaliacao?: string;
  estiloOuv?: string;

  tipo?: string;
}

export interface CamadaTiff extends Camada {
  nomeArquivo: string;
}

export interface EstiloOuv {
  type: string;
  color: string;
  fill: string;
  fillOpacity: number;
  weight: number;
  pointSize: number;
  pointSymbol: string;
  labelActive: string;
  labelSize: string;
  labelDecimal: number;

  labelColor: string;
  labelFont: string;
  labelShadowColor: string;
  labelShadowSize: number;

  labelId: number;
  labelName: string;
  labelMinScale: number;
  labelMaxScale: number;
  lineType: string;
  fillPattern: any;
  minZoom: number;
  maxZoom: number;
  thematicMapField: string;
  thematicMapSubtitles: any[];
  thematicMapClasses: ThematicMapClass[];
}

interface ThematicMapClass {
  categoria: string;
  cor: string;
  preenchimento: string;
  intervalo1: string;
  intervalo2: string;
  simboloPonto: string;
  tipoLinha: string;
  tamanhoPonto: number;
  escalaMin: number;
  escalaMax: number;
  espessura: string;
}

export interface Estilo {
  cor?: string;
  espessura?: number;
  preenchimento?: string;
  tipoLinha?: string;
  simboloPonto?: number;
  tamanhoPonto?: number;
  rotuloAtivo?: boolean;
  rotuloNome?: string;
  rotuloCor?: string;
  rotuloCorSombra?: string;
  rotuloFonte?: string;
  rotuloDecimal?: number;
  rotuloTamanhoSombra?: number;
  rotuloId?: number;
  rotuloEscalaMax?: number;
  rotuloEscalaMin?: number;
  tamanhoRotulo?: number;
  rotuloAnguloId?: number;
  rotuloAnguloNome?: string;
  legenda?: any[];
  mapaTematico?: any[];
  idCampoMapaTematico?: number;
  campoMapaTematico?: string;
  // minZoom?: number;
  // maxZoom?: number;
  escalaMax?: number;
  escalaMin?: number;
  fillPattern?: IFillPattern;
}

export interface IFillPattern {
  pattern?: string;
  size?: number;
  spacing?: number;
  angle?: number;
  scale?: number;
  offset?: number;
  color?: string;
}
